import { render } from "./ContentDisplay.vue?vue&type=template&id=5e890d5c"
import script from "./ContentDisplay.vue?vue&type=script&lang=js"
export * from "./ContentDisplay.vue?vue&type=script&lang=js"
script.render = render

export default script